export class FiltroBuscaMunicipios {

    uf: string;
    nomeMunicipio: string;

    constructor(unidadeFederacao: string, nomeMunicipio : string) {
        this.uf = unidadeFederacao;
        this.nomeMunicipio = nomeMunicipio;
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/filter/filtro-municipios.ts